export enum TokenHoldersColumns {
    tokenID = "token_id",
    address = "address",
    holdingTokenValue = "holding_token_value",
    holdingTokenValueUSD = "holding_token_value_usd",
    tokenName = "token_name",
    assetID = "asset_id",
    assetName = "asset_name",
    assetTicker = "asset_ticker",
    networkID = "network_id",
    networkName = "network_name",
}

export interface TokenHolder {
    token_id: string;
    address: string;
    holding_token_value: number;
    holding_token_value_usd: number;
}
